var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckmarkBig = function SvgCheckmarkBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.986 11.056"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.056a1.003 1.003 0 0 1-.71-.297L.29 6.203a1 1 0 1 1 1.42-1.407l3.77 3.818L13.256.316a1 1 0 0 1 1.46 1.367L6.23 10.74a1.003 1.003 0 0 1-.717.316z"
  })));
};
export default SvgCheckmarkBig;